import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AdminService } from 'src/app/shared/services';
import { SignUpNewUserRequest, SignupRequestDataVM } from 'src/app/shared/models/admin';

@Component({
  selector: 'app-approve-user-modal',
  templateUrl: './approve-user-modal.component.html',
  styleUrls: ['./approve-user-modal.component.scss']
})
export class ApproveUserModalComponent implements OnInit {
  selectedUserId: number = -1;
  selectedUserName: string = '';

  userTypes = [
    { name: 'Customer', code: 'CUS' },
    { name: 'Distributor', code: 'DIS' }
  ];
  selectedUserType: any = null;

  requestData: SignupRequestDataVM = {};
  isGettingData: boolean = false;
  isSaving: boolean = false;
  loadFailed: boolean = false;

  constructor(
    private adminService: AdminService,
    private dialogConfig: DynamicDialogConfig,
    private dialogRef: DynamicDialogRef
  ) {
    this.selectedUserId = this.dialogConfig.data?.selectedUserId ?? -1;
    this.selectedUserName = this.dialogConfig.data?.selectedUserName ?? '';
  }

  ngOnInit(): void {
    this.loadRequestData();
  }

  loadRequestData(): void {
    this.isGettingData = true;
    this.adminService.getSignUpRequestDataByUserId(this.selectedUserId).subscribe({
      next: (data) => {
        this.isGettingData = false;
        if (data && data.isSuccess && data.signupRequestDataVM) {
          this.requestData = data.signupRequestDataVM;
        } else {
          this.loadFailed = true;
        }
      },
      error: () => {
        this.isGettingData = false;
        this.loadFailed = true;
      }
    });
  }

  cancel(): void {
    this.dialogRef.close({ refreshTable: false });
  }

  save(): void {
    if (!this.selectedUserType) {
      return;
    }

    this.isSaving = true;

    const signUpRequest: SignUpNewUserRequest = {
      userId: this.selectedUserId,
      userType: this.selectedUserType.name.toLowerCase(),
      organizationName: this.requestData.organizationName,
      country: this.requestData.country,
      email: this.requestData.email,
      contactNumber: this.requestData.contactNumber,
      name: this.requestData.name,
      website: this.requestData.webSite,
      parentId: 0 // approved by an admin — same rule sign-up-new-user.component uses
    };

    this.adminService.signUpNewUser(signUpRequest).subscribe({
      next: (data) => {
        this.isSaving = false;
        if (data && data.isSuccess) {
          this.dialogRef.close({ refreshTable: true });
        }
      },
      error: () => {
        this.isSaving = false;
      }
    });
  }
}